// extracted by css-extract-rspack-plugin
export default {"checkbox":"_76eOC","indeterminate":"_1-Yec"};